/**
 * Created by weijialiu on 2017/10/30.
 * 灵犀数据埋点信息
 */
var analyticsInfo = {
  page: {
    electronicInvoice: {
      list: {
        pv: 'c_9t1157mh',
        clickGotoDetail: 'b_anqunc6c',
        clickDeleteBtn: 'b_np2m02b5',
        confirmCancel: 'b_eporj5n1',
        confirmDelete: 'b_0ahd8sog',
        getListSuccess: 'b_yaaq8ui4',
        getListFail: 'b_vq6xx301'
      },
      detail: {
        pv: 'c_e7zxrbqr',
        clickGotoPreview: 'b_7d6x4hvq',
        clickGotoDownload: 'b_n5eyw3r6',
        clickWeiXinCard: 'b_order_c_4gucez3r_mc',
        clickGongZhongHao: 'b_order_c_80bvmmtv_mc',
        OFDReadMore: 'b_order_c_n32jy2qd_mc'
      },
      preview: {
        pv: 'c_b4culvhp'
      },
      download: {
        pv: 'c_4ssza4el',
        clickSendEmail: 'b_xvc37ogs'
      },
      eInvoiceSalesDetail: {
        pv: 'c_order_c_7i6he0ej'
      }
    },
    list: {
      pv: 'c_bw81sfst',
      getDataSuccess: 'b_1rd1dzoo',
      getDataFailed: 'b_oahr7trh',
      clickAddTitleBtn: 'b_hli1taru',
      clickUseBtn: 'b_xbclg57o',
      clickCompleteBtn: 'b_zgyj7dvv',
      clickTitleToDetail: 'b_4au58xs0',
      setDefault: 'b_5unbng0w',
      getTitleListException: 'b_order_c_4rbcwy9i_mc',
      cancelDelete: 'b_order_c_cant3vaf_mc',
      confirmDelete: 'b_order_c_nnrstcqz_mc',
      titleListDiffCount: 'b_order_c_xozp1c8n_mc'
    },
    add: {
      pv: 'c_9ta7t456',
      clickOnlySaveBtn: 'b_6yz43xve',
      clickSaveAndUseBtn: 'b_gafowcn5',
      startRequestSave: 'b_5nt15m70',
      saveSuccess: 'b_wnwll0vy',
      saveFailed: 'b_7hylulr9',
      startRequsetSuggestTitle: 'b_r3rj526p',
      suggestUIAppear: 'b_c6zzacwy',
      userClickSuggestTitle: 'b_pme72oet',
      userModifySuggestData: 'b_v1ua4aj6',
      userModifyTitleOrTax: 'b_fso3c68w',
      requestSuggestTitleSuccess: 'b_v9pwv791',
      requestSuggestTitleFailed: 'b_sz492f9g',
      selectInvoice: 'b_order_c_yho4o9i1_mc',
      importFromWX: 'b_order_c_cz6hg6o0_mc',
      cancelImportTitle: 'b_order_c_hzb3yuto_mc',
      cancelDefaultTitle: 'b_order_c_n6g22deq_mc',
      showClipboardInvoice: 'b_order_c_5cldskny_mv',
      confirmClipboardInvoice: 'b_order_c_5cldskny_mc',
      getClipboardData: 'b_order_c_zx32v0nx_mc',
      querySepcialInvoiceStatus: 'b_order_c_xkweqtje_mc',
      specialInvoiceClickSuggestTitle: 'b_order_c_hjzu1q45_mc'
    },
    edit: {
      pv: 'c_xq5e9r1r',
      clickDeleteBtn: 'b_h3izvmkt',
      cancleDelete: 'b_hxt2bofl',
      confirmDelete: 'b_wv3368rw',
      startRequestDelete: 'b_70w7m2fj',
      deleteSuccess: 'b_74g74lfm',
      deleteFailed: 'b_dmph71ww',
      clickOnlySaveBtn: 'b_4yyg9wm7',
      clickSaveAndUseBtn: 'b_9599s0sq',
      modifySuccess: 'b_pg8n41af',
      modifyFailed: 'b_7wgkoj6v',
      cancelDefaultTitle: 'b_order_c_hpyshkl3_mc',
      querySepcialInvoiceStatus: 'b_order_c_xpex0enh_mc',
      specialInvoiceClickSuggestTitle: 'b_order_c_r4wbnu4p_mc'
    },
    detail: {
      pv: 'c_38zwafqk',
      clickEditBtn: 'b_f1tzwwzn'
    },
    error: {
      pv: 'c_r334xzmn'
    },
    invoice: {
      // 合作引导页
      cooperation: {
        pv: 'c_gib5z0su',
        goToNext: 'b_yeuakm3f'
      },
      // 开票
      invoice: {
        pv: 'c_ykhxolgi',
        wxPV: 'c_zf0dw4gd',
        mtappPV: 'c_1857w6fx',
        dpappPV: 'c_vl37wjed',
        dxappPV: 'c_ykhxolgi',
        // 需要修改
        otherPV: 'c_hy31xivm',
        // suggest相关的复用之前的
        clickApplyInvoiceBtn: 'b_jm1acfil',
        clickChangeBtn: 'b_tlrqrc7v',
        clickQuestionIcon: 'b_tns6578m',
        addNewTitle: 'b_order_c_stgh4wob_mc'
      },
      // 列表
      list: {
        pv: 'c_6kluym4s',
        useTitle: 'b_09tiwoyn',
        useNewTitle: 'b_lwteo4ov'
      },
      // 成功
      success: {
        pv: 'c_3l66uvgo'
      },
      // https://ocean.sankuai.com/config/#/new-page-detail/41988127/page?channelId=185
      note: {
        pv: 'c_order_c_va3mckan',
        gotoNext: 'b_order_c_362zk8v2_mc'
      },
      // 电子发票申请开票 相关
      eInvoice: {
        pv: 'c_cv1j1w03',
        fromWX: 'c_f6tft6dj',
        fromMTApp: 'c_5iuaymnw',
        fromDPApp: 'c_xh7xu4nb',
        fromOther: 'c_c9dwd591',
        clickChangeBtn: 'b_erlehx8k',
        clickRequestBtn: 'b_hju7xtu9',
        clickCancelBtn: 'b_order_c_w2atxwhq_mc',
        clickConfirmBtn: 'b_order_c_ffwne4q2_mc',
        comeFromQrcode: 'c_order_c_dbxg559j',
        addNewTitle: 'b_order_c_nwts27az_mc',
        autoInputReceiverInfo: 'b_order_c_1pnd2cay_mc',
        userClickSuggestTitle: 'b_order_c_udmy7ios_mc',
        startRequsetSuggestTitle: 'b_order_c_46qk9qeb_mc',
        requestSuggestTitleSuccess: 'b_order_c_se5fgf4m_mc',
        suggestUIAppear: 'b_order_c_rz6mf6f5_mc',
        requestSuggestTitleFailed: 'b_order_c_19xyuz66_mc',
        userModifySuggestData: 'b_order_c_7u9iq6kh_mc',
        userModifyTitleOrTax: 'b_order_c_6p9v294x_mc',
        selectInvoice: 'b_order_c_84x8vgj9_mc',
        showClipboardInvoice: 'b_order_c_dir4nn4m_mv',
        confirmClipboardInvoice: 'b_order_c_dir4nn4m_mc',
        getClipboardData: 'b_order_c_4zerg2s6_mc'
      },
      eHistory: {
        pv: 'c_cu5s12ny',
        gotoDetail: 'b_52bg6g9w'
      },
      eSuccess: {
        pv: 'c_5z0zs5z4',
        clickWeiXinCard: 'b_order_c_vhck4mb7_mc',
        clickGongZhongHao: 'b_order_c_vfu540a4_mc',
        clickDone: 'b_959bkstd'
      },
      eResult: {
        interfaceError: 'c_svmwi7n4',
        invoiceIsUsed: 'c_32yqtvzz',
        outOfDate: 'c_zzv41i5t'
      },
      register: {
        cid: 'c_ao1ew49l',
        bids: {
          registerBtn: 'b_tangeb82',
          taxChange: 'b_dngonvy3'
        }
      },
      registerStatus: {
        cid: 'c_yy0hrdiw',
        bids: {
          error: 'b_ojdz8e2b'
        }
      }
    },
    ofd: {
      ofdView: {
        pv: 'c_order_c_v05d542d',
        clickDownloadOFD: 'b_order_c_x973hydy_mc',
        clickDownloadReader: 'b_order_c_vvy7n6n7_mc',
        copyURL: 'b_order_c_cpva2ghb_mc'
      }
    },
    confirmPopUp: {
      pv: 'c_order_c_v8np1avl',
      clickShowMoreBtn: 'b_order_c_rkb9jvsi_mc',
      showMore: 'b_order_c_rkb9jvsi_mv',
      confirmBtn: 'b_order_c_seumm9ah_mc'
    }
  }
};
export default analyticsInfo;